"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var CARDS_COUNT = 16;
var MobileGames = function (_a) {
    var category = _a.category, games = _a.games, gameCardPlaceholder = _a.gameCardPlaceholder, titlePosition = _a.titlePosition, navigationTheme = _a.navigationTheme, navigationPosition = _a.navigationPosition;
    var t = (0, next_intl_1.useTranslations)('translation');
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var gamesInSlide = (0, react_1.useMemo)(function () {
        return breakpoints.mobile ? apps_shared_1.gamesInOneSlide.mobile : apps_shared_1.gamesInOneSlide.tablet;
    }, [breakpoints.mobile]);
    // const gamesBlocks = useGenerateSlideBlocks({
    //   cards: games,
    //   cardsInSlide: breakpoints.mobile
    //     ? gamesInOneSlide.mobile
    //     : gamesInOneSlide.tablet,
    // })
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
        react_1.default.createElement(ui_components_1.TopBar, { title: t("".concat(category)), showNavigationButtons: false, linkAddress: generateUrlWithLang("/games/".concat(category)), titlePosition: titlePosition, navigationTheme: navigationTheme, navigationPosition: navigationPosition }),
        games && games.length > 0 ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.slide }, games === null || games === void 0 ? void 0 : games.slice(0, CARDS_COUNT).map(function (game, idx) { return (react_1.default.createElement(ui_components_1.MobileGameCard, { key: "".concat(game.id).concat(idx), title: game.title, gameId: game === null || game === void 0 ? void 0 : game.id, slug: game === null || game === void 0 ? void 0 : game.slug, gameCardPlaceholder: gameCardPlaceholder, gameInfoModalKey: apps_shared_1.POPUP_CONSTANTS.GAME_INFO_MODAL })); })))) : (react_1.default.createElement(ui_components_1.EmptyGamesSliderPlaceholder, { gamesInSlide: gamesInSlide })),
        navigationPosition === 'bottom' && (react_1.default.createElement(ui_components_1.BottomBar
        // setPrevSlide={swiper?.slidePrev}
        // setNextSlide={swiper?.slideNext}
        , { 
            // setPrevSlide={swiper?.slidePrev}
            // setNextSlide={swiper?.slideNext}
            showNavigationButtons: false, linkAddress: generateUrlWithLang("/games/".concat(category)), navigationTheme: navigationTheme }))));
};
exports.default = MobileGames;
